var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.src)?_c('div',{staticClass:"wrapper"},[_c('div',{staticClass:"point",style:(_vm.pointStyle)}),_c('img',{staticClass:"thumbnail",attrs:{"src":_vm.src,"alt":""},on:{"click":_vm.selectPoint}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }